import { signInWithCustomToken } from 'firebase/auth';
import { adminHubAuth } from '../config/firebase.js';
import { buildApiUrl } from './apiBase.js';
import { bootStart, bootEnd } from './bootTiming.js';

export const signOutEverywhere = async () => {
  try {
    await fetch(buildApiUrl('/api/revoke-session'), {
      method: 'POST',
      credentials: 'include'
    });
  } catch {
    // Cookie が無くても続行
  }

  await adminHubAuth.signOut().catch(() => {});
};

export async function getFirebaseSignInProvider(authUser) {
  if (!authUser) return null;
  try {
    const result = await authUser.getIdTokenResult();
    return result.signInProvider || result.claims?.firebase?.sign_in_provider || null;
  } catch {
    return authUser.providerData?.[0]?.providerId || null;
  }
}

export const isCustomTokenSignIn = (provider) => provider === 'custom';
export const isGoogleSignInProvider = (provider) => provider === 'google.com';

/**
 * Session Cookie から synapseadminhub Firebase Auth を復元
 */
export const restoreAdminHubAuthFromSession = async () => {
  try {
    bootStart('auth:restore-token-api');
    let response;
    let data = {};
    try {
      response = await fetch(buildApiUrl('/api/auth/restore-firebase-token'), {
        method: 'POST',
        credentials: 'include'
      });
      data = await response.json().catch(() => ({}));
      bootEnd('auth:restore-token-api', response.ok ? 'ok' : `HTTP ${response.status}`);
    } catch (fetchErr) {
      bootEnd('auth:restore-token-api', `error: ${fetchErr?.message || 'unknown'}`);
      throw fetchErr;
    }
    if (!response.ok || !data.customToken) {
      return false;
    }
    bootStart('auth:signInWithCustomToken');
    try {
      await signInWithCustomToken(adminHubAuth, data.customToken);
      bootEnd('auth:signInWithCustomToken');
    } catch (signInErr) {
      bootEnd('auth:signInWithCustomToken', `error: ${signInErr?.message || 'unknown'}`);
      throw signInErr;
    }
    return true;
  } catch (err) {
    console.warn('[Auth] Admin Hub 復元エラー:', err?.message || err);
    return false;
  }
};
